import { Component, Input, OnInit } from '@angular/core';
import { ApiCoverageDetail, ApiSublimit } from '@bhtp-client-api/base';
import { CustomCurrencyUsdPipe } from './custom-currency-usd.pipe';

import { CoverageService } from './coverage.service';

@Component({
    selector: 'included-coverage-display',
    template: require('./included-coverage-display.component.html')
})
export class IncludedCoverageDisplayComponent implements OnInit {
    @Input() public coverage: ApiCoverageDetail;
    /**
     *  Should the selected coverage limit be shown?
     *      This should only be true if we're displaying
     *      purchased optional coverages to look like included coverages.
     */
    @Input() public showSelectedCoverageLimit: boolean = false;
    @Input() public displayCoveragePayoutType: boolean;

    public get limitDisplayText(): string {
        let displayText: string;
        let coverageCanPickLimit = (this.coverage.limits && this.coverage.limits.length > 1);

        if ((this.showSelectedCoverageLimit && !this.coverage.percentageLimitofTripCost) || coverageCanPickLimit) {
            displayText = new CustomCurrencyUsdPipe().transform(this.coverage.coverageLimit);
        } else {
            displayText = this.coverage.coverageLimitDisplayText;
        }

        return displayText;
    }

    // Show View Acknowledgement link if there are no error messages and there are acknowledgements
    public get showAcknowledgement(): boolean {
        return this.coverage.acknowledgements && this.coverage.acknowledgements.length > 0;
    }

    private showDescription: boolean = false;
    private coverageIcon: string;

    constructor(private coverageService: CoverageService) {
    }

    public ngOnInit(): void {
        this.coverageIcon = this.coverageService.getCoverageIcon(this.coverage);
    }

    public toggleDescription(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.showDescription = !this.showDescription;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/included-coverage-display.component.ts